import api from "./base";

export const createBayouCustomer = (customer: object) =>
  api
    .post(`integrations/create_bayou_customer/`, customer)
    .then((res) => res.data);

export const createUtilityApiForm = (form: object) =>
  api
    .post(`integrations/create_utilityapi_form/`, form)
    .then((res) => res.data);
